module.exports = __webpack_public_path__ + "static/media/img_search_null.bdf2cb57.svg";